module.exports = __webpack_public_path__ + "static/img/3.1edd942.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel-2/3.jpg
// module id = 9Fga
// module chunks = 1